import React from 'react';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import animator from '../../../../helpers/animator';
import './TaskActivityCard.scss';

// TODO: this component is duplicated
export default class TaskActivityCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();

  }

  componentDidMount() {
    super.componentDidMount();
  }

  handleCreateImage(){
    if(this.props.user){
      if(this.props.user.profile_image){
        //create user image 
        return <img className='user-image' src={this.props.user.profile_image} alt='' />;
      }
      else{
        const user = this.props.user;
        //create default letters
        const initials = (user.first_name ? user.first_name.substr(0, 1).toUpperCase() : '') + (user.last_name ? user.last_name.substr(0, 1).toUpperCase() : '');
        return (
          <div className="default-user-image-container">
            <div className="default-user-image" />
            <div className="user-initials">{initials}</div>
          </div>
        );
      }
    }
    else {
      return <div style={{ height: 28, borderRadius: '50%', width: 28, backgroundColor: 'gray' }} />;
    }
  }

  handleSeparateTimeDate(){
    if (this.props.date){
      let d = new Date(this.props.date);
      let date = (d.getMonth() + 1) + '/' + d.getDate() + '/' +  d.getFullYear();

      let hours = d.getHours();
      let meridiem = hours >= 12 ? 'pm' : 'am';
      if(hours == 0){
        hours = 12;
      }
      else if (hours > 12){
        hours -= 12;
      }
      let minutes = d.getMinutes();
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      let time = hours + ':' + minutes + ' ' + meridiem;
      return date + '\u00A0\u00A0|\u00A0\u00A0' + time;
    }
    else {
      return '';
    }

  }
  render() {
    let image = this.handleCreateImage();
    let timestamp = this.handleSeparateTimeDate();
    return (
      // Replace with the appropriate HTML
      <div className="task-activity-card">
        <hr className='activity-card-underline' />
        <div className='content-section'>
          <div className="image-section">
            {image}
          </div>
          <div className="data-section"> 
            <div className="activity-name">{this.props.caption || (this.props.user ? (this.props.user.first_name + ' ' + this.props.user.last_name) : '')}</div>
            <div className="activity-caption">{this.props.caption}</div>
            <div className="activity-message">{this.props.message}</div>
            <div className="activity-timestamp">{timestamp}</div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskActivity/TaskActivityCard/index.js